import { defineMessages } from 'react-intl'

export const cancelSubscriptionMessages = defineMessages({
  ctaBtn: {
    id: 'cancelSubscription.ctaBtn',
    description:
      'CTA button text on modal asking to Cancel/Downgrade subscription',
    defaultMessage: 'Yes, Cancel',
  },
  cancelBtn: {
    id: 'cancelSubscription.cancelBtn',
    description:
      'Cancel button text on modal asking to cancel all subscriptions',
    defaultMessage: 'No, Keep',
  },
  title: {
    id: 'cancelSubscription.title',
    description:
      'A title of modal when user tries to cancel/downgrade subscription',
    defaultMessage: 'Cancel Savant Essentials?',
  },
  confirmTextSub: {
    id: 'cancelSubscription.confirmTextSub',
    description:
      'Modal confirm text for canceling/downgrade of active subscription',
    defaultMessage:
      'Are you sure you wish to cancel {planName}? {br}{br}{planName} will end on {planEndDate}{br} if you cancel.',
  },
})
